<template>
    <component
        :is="require(`../../assets/icons/${name}.svg`).default"
        :view-box.camel="viewBox"
        class="icon"
        :class="{ 'rtl-flip': rtlFlip }"
        aria-hidden="true"
    />
</template>

<script>

export default {
    name: 'DsSvgIcon',

    props: {
        /**
         * The name of the icon
         */
        name: {
            type: String,
            required: true,
            default: '',
        },
    },

    computed: {
        rtlFlip() {
            const name = this.name.toLowerCase();

            return name.includes('left') || name.includes('right');
        },

        viewBox() {
            return '0 0 24 24';
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../styles/common";

    .icon {
        $size: #{var(--icon-size, #{$font-size-icons})};

        @include transition(var(--icon-transition, all));

        cursor: var(--icon-cursor, inherit);
        height: $size;
        width: $size;
        min-height: $size;
        min-width: $size;
        fill: var(--icon-color, currentcolor);
        margin: var(--icon-margin, 0);
        stroke: none;
    }

    .rtl-flip {
        @include rtl-flip;
    }
</style>

<style lang="scss">
    .is-icon-target,
    .is-icon-target * {
        stroke-width: inherit;
        fill: none;
        vector-effect: non-scaling-stroke;
    }
    .is-icon-dot {
        stroke-width: 0;
        fill: inherit;
    }
</style>
